/** 全站主题配置（主按钮等在此调节） */
export const ThemeConfig = {
  /** 所有页面主按钮（Ant Design `type="primary"`）背景色 */
  primaryButtonBackgroundColor: 'rgb(7, 128, 172)',
  /** Input / Select 等 placeholder 文字色（略深于 Ant Design 默认） */
  placeholderTextColor: 'rgba(0, 0, 0, 0.38)',
} as const;
